import { Star, StarHalf, Users } from '@phosphor-icons/react';
import Carousel from '../../../components/molecules/Carousel';

const LinkingFlowOpinion = () => {
	return (
		<div className='bg-white rounded-xl shadow px-6 py-5 md:py-8 flex flex-col gap-6 relative overflow-hidden'>
			<div className='flex items-center justify-between gap-2'>
				<div className='flex items-center gap-1'>
					<Users
						size={16}
						weight='bold'
					/>
					+ 135,000 usuarios
				</div>
				<div className='flex items-center gap-1 text-h-warning-50'>
					<Star
						size={16}
						weight='fill'
					/>
					<Star
						size={16}
						weight='fill'
					/>
					<Star
						size={16}
						weight='fill'
					/>
					<Star
						size={16}
						weight='fill'
					/>
					<StarHalf
						size={16}
						weight='fill'
					/>
					<span className='text-h-primary-10 ml-1'>4.6</span>
				</div>
			</div>

			<Carousel
				autoplaySpeed={7000}
				showDots={false}
				className='w-full z-10'
			>
				{[
					'"La forma más fácil y segura de presentar mi declaración anual con heru. Antes me tardaba horas, ahora en minutos ya está todo listo y sin complicaciones."',
					'"Me ayudaron con mis trámites del SAT, todo fue muy rápido y sencillo. El equipo de soporte siempre estuvo pendiente de mis dudas y me guiaron en cada paso."',
					'"La plataforma de facturación es mucho más intuitiva que la del SAT. Pude emitir mis facturas sin errores y el proceso fue súper claro."',
					'"Confío en heru para llevar mi contabilidad, siempre me resuelven mis dudas. Me siento acompañado y seguro de que todo está en orden con mis impuestos."',
					'"El costo es muy accesible y el soporte es de primera. No pensé que fuera tan fácil tener ayuda profesional para mis declaraciones."',
					'"heru me ahorró mucho tiempo con mi declaración anual, súper recomendado. Además, me explicaron todo de forma sencilla y transparente."',
					'"La atención personalizada me ayudó a entender mis impuestos. Ahora sé exactamente qué tengo que hacer y no me siento perdido como antes."',
					'"La plataforma es muy fácil de usar y me da mucha confianza. Pude conectar mi cuenta del SAT sin problemas y todo el proceso fue seguro."',
					'"Gracias a heru, puedo facturar en dos clics. Antes era un dolor de cabeza, ahora es parte de mi rutina y no me preocupa en lo absoluto."',
				].map((text, index) => (
					<div
						key={index}
						className='w-full leading-tight text-base'
					>
						{text}
					</div>
				))}
			</Carousel>
		</div>
	);
};

export default LinkingFlowOpinion;
